import { takeLatest, put, call, select, take } from 'redux-saga/effects';
import Cookie from 'js-cookie';
import moment from 'moment-timezone';
import { rehydrateBookingSession, sendCheckoutHotelDataToAnalytics, sendCheckoutGiftDataToAnalytics, sendCheckoutPassDataToAnalytics, submitNewCheckinDate, checkinDateProcessSuccess, checkinDateProcessFailure } from '../actions';
import { Router } from "../../routes";
import { axiosInstance, slugify, objectIsEmpty } from '../../utils';
import { updateProduct } from './userProduct';

import {
  CHECKOUT_PAYMENT_REQUEST,
  CHECKOUT_PAYMENT_SUCCESS,
  CHECKOUT_PAYMENT_FAILURE,
  CHECKOUT_PAYMENT_HAS_ACCOUNT,
  CHECKOUT_PAYMENT_REDIRECTED,
  CHECKOUT_PAYMENT_FREE,
  CHECKOUT_PAYMENT_FREE_FAILURE,
  REHYDRATE_USER_SESSION,
  REHYDRATE_USER_BOOKING,
  SIGNUP_SUCCESS,
  CHECKOUT_PAYMENT_RESET,
  CHECKOUT_GIFT_SUCCESS,
  CHECKOUT_HOTEL_SUCCESS,
  CHECKOUT_PASS_SUCCESS, FETCH_USER_CARDS_REQUEST,
  CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS,
} from '../types';

let type = Cookie.get('type');

function* finalizePayment(value, isAdditional) {
  const { booking, gift, pass } = value;
  Cookie.remove('ch_ref');

  yield put({ type: CHECKOUT_PAYMENT_SUCCESS });

  if (type === 'checkout') {

    let userProduct = yield select(state => state.userProduct);
    let bookingManagement = yield select(state => state.bookingManagement);

    const customerObject = Cookie.get('customerObject');
    const parsedCustomer = JSON.parse(customerObject);
    if (!isAdditional && userProduct.product.name.length === 0) {
      yield take(REHYDRATE_USER_SESSION);
      userProduct = yield select(state => state.userProduct);
    } else if (!isAdditional) {
      userProduct = yield select(state => state.userProduct);
    }

    if (isAdditional && bookingManagement.hotel === null) {
      yield put(rehydrateBookingSession(localStorage.getItem('userBooking')));
      bookingManagement = yield select(state => state.bookingManagement);
    } else if (isAdditional) {
      bookingManagement = yield select(state => state.bookingManagement);
    }

    let productId;
    let productName;
    let hotelName;
    let marketName;
    let maxGuests;
    let id;

    if (isAdditional) {
      const { hotel } = bookingManagement;
      productId = hotel.productId;
      productName = hotel.productName;
      hotelName = hotel.hotelName;
      marketName = hotel.neighborhood;
      id = hotel.bookingId;
    } else {
      const { product, hotel } = userProduct;
      productId = product.id;
      productName = product.name;
      maxGuests = product.maxGuests;
      hotelName = hotel.name;
      marketName = hotel.market;
    }

    const usingCredits = yield select(state => state.payment.usingCredits);
    if (usingCredits) {
      yield put({ type: CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS });
    }

    const { date: checkinDate, userId } = parsedCustomer;
    const date = new Date(new Date().getTime() + 180 * 1000);
    Cookie.set('booked', JSON.stringify({checkinDate, userId, productId, }), { path: '/', expires: date });
    const newDate = yield select(state => state.bookingManagement.changeCheckingDate.newDate);
    if (isAdditional) {
      yield put(submitNewCheckinDate(newDate));
    }
    if(!isAdditional) {
      yield put(
        sendCheckoutHotelDataToAnalytics(
          {
            id: booking.BookingId,
            amount: maxGuests ? Math.ceil(parsedCustomer.quantity / maxGuests) : parsedCustomer.quantity,
            total: booking.TotalPrice
          }
        )
      );
    }

    const routeObject = {
      marketName: slugify(marketName),
      hotelName: slugify(hotelName),
      productName: slugify(productName),
      productId,
    }

    if(isAdditional) {
      routeObject.id = id;
    } else {
      routeObject.id = booking.BookingId;
    }

    Router.pushRoute(
      'booking',
      routeObject,
    );



  } else if (type === 'gift') {
    yield put(
      sendCheckoutGiftDataToAnalytics(
        {
          id: gift.Id,
          total: gift.TotalPrice
        }
      )
    );

    Router.pushRoute(
      'gift-confirmation',
      {
        giftCardId: gift.Id
      }
    );
  } else if (type === 'pass') {
    yield put(
      sendCheckoutPassDataToAnalytics(
        {
          total: pass.TotalPrice
        }
      )
    );

    Router.pushRoute('pass-confirmation');
  }
}

function* handlePaymentResult(data) {
  if (data.paymentStatus) {
    const { paymentStatus, value } = data;

    const isAdditional = localStorage.getItem('isAdditional') === 'true';
    if (paymentStatus === 'paid' && value) {
      yield call(finalizePayment, value, isAdditional);
    } else {
      yield put({ type: CHECKOUT_PAYMENT_FAILURE, payload: value });
    }
  }
}

function* onSuccessRedirectSaga() {
  const result = Cookie.get('status');
  Cookie.remove('status');
  Cookie.remove('type');

  Cookie.remove('ch_ref');

  yield call(handlePaymentResult, JSON.parse(result));
}

function redirectToPaymentPage(url) {
  Router.pushRoute(url);
}

function* payWithStripe(stripeInstance) {
  const customerObject = Cookie.get('customerObject');
  const parsedCustomer = JSON.parse(customerObject);
  let apiUrl;

  const isAdditional = yield select(state => state.bookingManagement.changeCheckingDate.isPaying);
  const userData = yield select(state => state.user.userData);
  const guests = yield select(state => state.userPreferences.guests);
  const maxGuests = yield select(state => state.userProduct.product.maxGuests);
  const bookingManagement = yield select(state => state.bookingManagement);
  const userHotel = yield select(state => state.userProduct.hotel);
  const userPreferences = yield select(state => state.userPreferences);
  const usingCredits = yield select(state => state.payment.usingCredits);
  const price = yield select(state => state.userProduct.product.price.total);

  if (type === 'checkout') {
    apiUrl = `${isAdditional ? 'booking/additional_payment' : 'payment'}/stripe`;
  } else if (type === 'gift') {
    apiUrl = 'gift/payment/stripe'
  } else if (type === 'pass') {
    apiUrl = 'subs/payment/stripe';
  }

  let isCreditsEnough;

  if (usingCredits) {
    const { last24freeDayPass, credits: { total }, subscription} = userData;
    const productAmount = Math.ceil(guests / maxGuests);

    const prodType = isAdditional ? bookingManagement.hotel.type : userHotel.hotelType;
    const date = isAdditional ? bookingManagement.changeCheckingDate.newDate : userPreferences.date;

    const hasFreePass = !isAdditional && userData && !objectIsEmpty(subscription) && !last24freeDayPass && prodType === 0 && moment(date).isBefore(moment().add(1, 'day'))
    const countedPrice = (hasFreePass ? productAmount - 1 : productAmount) * price;

    if (usingCredits) {
      isCreditsEnough = total > countedPrice;
    }
  }
  let token = null;
  let error = null;
  if (!isCreditsEnough) {
    const data = yield call(stripeInstance.createToken, { name: `${parsedCustomer.firstName || ''} ${parsedCustomer.lastName || ''}` });
    token = data.token;
    error = data.error;
  }

  if (token || isCreditsEnough) {
    try {

      let paymentObj = {
        ...parsedCustomer,
      };

      if(!isCreditsEnough) {
        paymentObj.stripeToken = token.id;
      };

      const { data: { status, url, user }, data } = yield call(axiosInstance.post, apiUrl, paymentObj);
      localStorage.setItem('isAdditional', isAdditional);
      if (status === 'paid') {

        yield call(finalizePayment, data, isAdditional);
      } else if (status === 'redirect') {
        Cookie.set('ch_ref', window.location.pathname, { path: '/' });
        yield call(redirectToPaymentPage, url);
      } else {
        if (isAdditional) {
          yield put(checkinDateProcessFailure('Error'));
        }
        yield put({ type: CHECKOUT_PAYMENT_FAILURE });
      }

      if (user && user.tokens) {
        const { tokens: { token: jwt, refreshToken } } = user;
        if (Cookie.get('new')) {
          Cookie.remove('new', 'true', { path: '/' });
        } else {
          Cookie.set('new', 'true', { path: '/' });
        }
        Cookie.set('remember', 'true', { path: '/' });
        Cookie.set('jwt', jwt, { path: '/' });
        Cookie.set('refreshToken', refreshToken, { path: '/' });
        yield put({ type: SIGNUP_SUCCESS, payload: user });
      }
    } catch (err) {
      if (err.error) {
        if (isAdditional) {
          yield put(checkinDateProcessFailure(err.error));
        }

        yield put({ type: CHECKOUT_PAYMENT_FAILURE, payload: err.error });
        if (err.user && err.user.tokens) {
          const { tokens: { token: jwt, refreshToken } } = err.user;
          if (Cookie.get('new')) {
            Cookie.remove('new', 'true', { path: '/' });
          } else {
            Cookie.set('new', 'true', { path: '/' });
          }
          Cookie.set('remember', 'true', { path: '/' });
          Cookie.set('jwt', jwt, { path: '/' });
          Cookie.set('refreshToken', refreshToken, { path: '/' });
          yield put({ type: SIGNUP_SUCCESS, payload: err.user });
          yield put({ type: FETCH_USER_CARDS_REQUEST });
        }
      } else if (err === 'email exists') {
        yield put({ type: CHECKOUT_PAYMENT_HAS_ACCOUNT });
      } else {
        yield put({ type: CHECKOUT_PAYMENT_FAILURE });
        if (isAdditional) {
          yield put(checkinDateProcessFailure('Error'));
        }
      }
    }
  } else if (error) {
    yield put({ type: CHECKOUT_PAYMENT_FAILURE });
    if (isAdditional) {
      yield put(checkinDateProcessFailure(error));
    }
  }
  yield put({ type: CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS });
}

function* payWithStripePrefilledCard(stripeInstance, card) {

  const customerObject = Cookie.get('customerObject');
  const parsedCustomer = JSON.parse(customerObject);
  let apiUrl;
  const isAdditional = yield select(state => state.bookingManagement.changeCheckingDate.isPaying);

  if (type === 'checkout') {
    apiUrl = `${isAdditional ? 'booking/additional_payment' : 'payment'}/stripe`;
  } else if (type === 'gift') {
    apiUrl = 'gift/payment/stripe'
  } else if (type === 'pass') {
    apiUrl = 'subs/payment/stripe';
  }

  if (card && card.value) {
    try {
      const { data: { status, url, user }, data } = yield call(axiosInstance.post, apiUrl, {
        source: card.value,
        ...parsedCustomer,
      });
      if (status === 'paid') {
        yield call(finalizePayment, data, isAdditional);
      } else if (status === 'redirect') {
        localStorage.setItem('isAdditional', isAdditional);
        Cookie.set('ch_ref', window.location.pathname, { path: '/' });
        yield call(redirectToPaymentPage, url);
      } else {
        if (isAdditional) {
          yield put(checkinDateProcessFailure('Error'));
        }
        yield put({ type: CHECKOUT_PAYMENT_FAILURE });
      }

      if (user && user.tokens) {
        const { tokens: { token: jwt, refreshToken } } = user;
        if (Cookie.get('new')) {
          Cookie.remove('new', 'true', { path: '/' });
        } else {
          Cookie.set('new', 'true', { path: '/' });
        }
        Cookie.set('remember', 'true', { path: '/' });
        Cookie.set('jwt', jwt, { path: '/' });
        Cookie.set('refreshToken', refreshToken, { path: '/' });
        yield put({ type: SIGNUP_SUCCESS, payload: user });
      }
    } catch (err) {
      if (err.error) {
        yield put({ type: CHECKOUT_PAYMENT_FAILURE, payload: err.error });
      } else if (err === 'email exists') {
        yield put({ type: CHECKOUT_PAYMENT_HAS_ACCOUNT });
      } else {
        yield put({ type: CHECKOUT_PAYMENT_FAILURE });
      }
    }
  }
}

function* payWithPayPal() {
  const customerObject = Cookie.get('customerObject');
  const parsedCustomer = JSON.parse(customerObject);
  let apiUrl;
  const isAdditional = yield select(state => state.bookingManagement.changeCheckingDate.isPaying);
  const userData = yield select(state => state.user.userData);
  const guests = yield select(state => state.userPreferences.guests);
  const maxGuests = yield select(state => state.userProduct.product.maxGuests);
  const bookingManagement = yield select(state => state.bookingManagement);
  const userHotel = yield select(state => state.userProduct.hotel);
  const userPreferences = yield select(state => state.userPreferences);
  const usingCredits = yield select(state => state.payment.usingCredits);
  const price = yield select(state => state.userProduct.product.price.total);

  if (type === 'checkout') {
    apiUrl = `${isAdditional ? 'booking/additional_payment' : 'payment'}/paypal`;
  } else if (type === 'gift') {
    apiUrl = 'gift/payment/paypal'
  }

  let isCreditsEnough;

  if (usingCredits) {
    const { last24freeDayPass, credits: { total }, subscription} = userData;
    const productAmount = Math.ceil(guests / maxGuests);

    const prodType = isAdditional ? bookingManagement.hotel.type : userHotel.hotelType;
    const date = isAdditional ? bookingManagement.changeCheckingDate.newDate : userPreferences.date;

    const hasFreePass = !isAdditional && userData && !objectIsEmpty(subscription) && !last24freeDayPass && prodType === 0 && moment(date).isBefore(moment().add(1, 'day'))
    const countedPrice = (hasFreePass ? productAmount - 1 : productAmount) * price;

    if (usingCredits) {
      isCreditsEnough = total > countedPrice;
    }
  }
  if (isCreditsEnough) {
    const { data: { status }, data } = yield call(axiosInstance.post, apiUrl, parsedCustomer);
    if (status === 'paid') {
      yield call(finalizePayment, data, isAdditional);
    }
  } else {

    try {
      const { data: { status, url, user } } = yield call(axiosInstance.post, apiUrl, parsedCustomer);

      if (user && user.tokens) {
        const { tokens: { token: jwt, refreshToken } } = user;
        Cookie.set('new', 'true', { path: '/' });
        Cookie.set('remember', 'true', { path: '/' });
        Cookie.set('jwt', jwt, { path: '/' });
        Cookie.set('refreshToken', refreshToken, { path: '/' });
        yield put({ type: SIGNUP_SUCCESS, payload: user });
      }

      if (status === 'redirect') {
        Cookie.set('ch_ref', window.location.pathname, { path: '/' });
        localStorage.setItem('isAdditional', isAdditional);
        yield call(redirectToPaymentPage, url);
      } else {
        if (isAdditional) {
          yield put(checkinDateProcessFailure('Error'));
        }
        yield put({ type: CHECKOUT_PAYMENT_FAILURE });
      }
    } catch (err) {
      if (err.error) {
        yield put({ type: CHECKOUT_PAYMENT_FAILURE, payload: err.error });
        if (isAdditional) {
          yield put(checkinDateProcessFailure(err.error));
        }


        if (err.user && err.user.tokens) {
          const { tokens: { token: jwt, refreshToken } } = err.user;
          if (Cookie.get('new')) {
            Cookie.remove('new', 'true', { path: '/' });
          } else {
            Cookie.set('new', 'true', { path: '/' });
          }
          Cookie.set('remember', 'true', { path: '/' });
          Cookie.set('jwt', jwt, { path: '/' });
          Cookie.set('refreshToken', refreshToken, { path: '/' });
          yield put({ type: SIGNUP_SUCCESS, payload: err.user });
          yield put({ type: FETCH_USER_CARDS_REQUEST });
        }
      } else if (err === 'email exists') {
        yield put({ type: CHECKOUT_PAYMENT_HAS_ACCOUNT });
      } else {
        yield put({ type: CHECKOUT_PAYMENT_FAILURE });
        if (isAdditional) {
          yield put(checkinDateProcessFailure('Error'));
        }

      }
    }
  }
  yield put({ type: CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS });
}

function* checkoutPaymentSaga({ payload }) {
  const { stripeInstance, formData, card, type: checkoutType } = payload;

  const usingCredits = yield select(state => state.payment.usingCredits);
  const payingWith = yield select(state => state.userPreferences.payingWith.value);
  const bookingManagement = yield select(state => state.bookingManagement);

  const userData = yield select(state => state.user.userData);
  const promo = yield select(state => state.promo);
  const isAdditional = yield select(state => state.bookingManagement.changeCheckingDate.isPaying);
  localStorage.setItem('isAdditional', isAdditional);
  localStorage.setItem('userBooking', JSON.stringify({
    ...bookingManagement,
  }));

  let productId;
  let productName;
  let hotelName;
  let marketName;
  let date;
  let guests;
  let bookingId;

  if (isAdditional) {

    const { hotel, changeCheckingDate } = bookingManagement;
    productId = hotel.productId;
    productName = hotel.productName;
    hotelName = hotel.hotelName;
    marketName = hotel.neighborhood;
    bookingId = hotel.bookingId;
    guests = hotel.productAmount;
    date = moment(changeCheckingDate.newDate).format('YYYY-MM-DD');
  } else {
    const { product, hotel } = yield select(state => state.userProduct);
    const userPreferences = yield select(state => state.userPreferences);

    productId = product.id;
    productName = product.name;
    hotelName = hotel.name;
    marketName = hotel.market;
    guests = userPreferences.guests;
    date = moment(userPreferences.date).format('YYYY-MM-DD');
  }

  const {
    firstName,
    lastName,
    phone,
    emailAddress,
    recipientName,
    recipientMessage,
    recipientEmail,
    deliveryDate,
    planName,
    price,
  } = formData;
  let userId;
  type = checkoutType;
  Cookie.set('type', checkoutType, { path: '/' });

  if (userData) {
    userId = userData.userId;
  }

  if (type === 'checkout') {
    localStorage.setItem('ch_obj', JSON.stringify({
      marketName: slugify(marketName),
      hotelName: slugify(hotelName),
      productName: slugify(productName),
      productId,
    }));
  } else if (type === 'pass') {
    localStorage.setItem('ch_obj', JSON.stringify({ planName }));
  }

  const initialCustomerObject = {
    userId,
    firstName,
    lastName,
    phone,
    email: emailAddress,
    promo: (promo.status === 'success' && !isAdditional) ? promo.info.code : null,
  };
  let finalCustomerObject = initialCustomerObject;

  if (type === 'gift') {
    finalCustomerObject = {
      ...initialCustomerObject,
      recipientName,
      recipientMessage,
      recipientEmail,
      deliveryDate,
      price,
      cardName: `${price}$ Gift`
    }
  } else if (type === 'checkout') {
    finalCustomerObject = {
      ...initialCustomerObject,
      productId,
      quantity: guests,
      payByCredits: usingCredits,
    }
    if(isAdditional) {
      finalCustomerObject.newDate = date;
      finalCustomerObject.bookingId = bookingId;
    } else {
      finalCustomerObject.date = date;
    }
  } else if (type === 'pass') {
    finalCustomerObject = {
      ...initialCustomerObject,
      passId: planName,
    }
  }

  const customerObjectExp = new Date(new Date().getTime() + 180 * 1000);
  Cookie.set('customerObject', JSON.stringify(finalCustomerObject), { path: '/', expires: customerObjectExp });
  if (payingWith === 'newCard') {
    yield call(payWithStripe, stripeInstance);
  } else if (payingWith === 'paypal') {
    yield call(payWithPayPal);
  } else {
    yield call(payWithStripePrefilledCard, stripeInstance, card);
  }
}

function* checkoutFreeSaga() {
  const userProduct = yield select(state => state.userProduct);
  const date = yield select(state => state.userPreferences.date);

  const {
    hotel: {
      name: hotelName,
      market: marketName
    },
    product: {
      name: productName,
      id: productId,
    }
  } = userProduct;

  try {
    const { data } = yield call(axiosInstance.post, 'subs/day_pass_free', { date, productId });
    if(data.status !== 'fail') {
      yield put({ type: CHECKOUT_PAYMENT_SUCCESS });
      yield put(
        sendCheckoutHotelDataToAnalytics(
          {
            id: data.booking.BookingId,
            amount: 1,
            total: 0
          }
        )
      );

      Router.pushRoute(
        'booking',
        {
          marketName: slugify(marketName),
          hotelName: slugify(hotelName),
          productName: slugify(productName),
          productId,
          id: data.booking.BookingId
        }
      );
    } else {
      yield put({ type: CHECKOUT_PAYMENT_FREE_FAILURE, payload: data.error });
    }

  } catch (error) {
    let errorMessage;

    switch (error) {
      case 'Subscription 24h error':
        errorMessage = 'You already have 1 active free pass';
        break;
      case 'Subscription not found':
        errorMessage = 'You don\'t have a subscription';
        break;
      default:
        errorMessage = 'You already have 1 active free pass';
    }

    yield put({ type: CHECKOUT_PAYMENT_FREE_FAILURE, payload: errorMessage });
  }
}

function* resetCheckoutSaga() {
  const paymentStatus = yield select(state => state.payment.status);

  if (paymentStatus === 'paid') {

    yield put({ type: CHECKOUT_PAYMENT_RESET });
  }
}

function* updateInventoryOnFailure() {
  const productName = yield select(state => state.userProduct.product.name);
  if (type === 'checkout' && productName) {
    yield call(updateProduct, { payload: productName });
  }
}

export default function* saga() {
  yield takeLatest(CHECKOUT_PAYMENT_REQUEST, checkoutPaymentSaga);
  yield takeLatest(CHECKOUT_PAYMENT_FREE, checkoutFreeSaga);
  yield takeLatest(CHECKOUT_PAYMENT_REDIRECTED, onSuccessRedirectSaga);
  yield takeLatest(CHECKOUT_PAYMENT_FAILURE, updateInventoryOnFailure);
  yield takeLatest([CHECKOUT_GIFT_SUCCESS, CHECKOUT_HOTEL_SUCCESS, CHECKOUT_PASS_SUCCESS], resetCheckoutSaga);
}
